import { useContext, type Context } from 'react';
import { PwaContext, type PwaContextValue } from '../providers/PwaProvider';

const usePwa = () => useContext(PwaContext as Context<PwaContextValue>);

export default usePwa;
